import React from 'react'


export default function Assets() {
  return (
    <div 
      className="p-6 min-h-screen bg-cover bg-center"
    
    >
            <h1 className="text-2xl font-bold pt-14">Assets Page</h1>
            <p>Welcome to the Assets page.</p>
    </div>
  )
}
